import React from "react";

export default function TransactionIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 27 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round">
        <g
          id="Sidemenu-/-Item-Unselected"
          transform="translate(-19.000000, -6.000000)"
          stroke="#FFFFFF"
          strokeWidth="1.5">
          <g id="Icons-/-Line-/-Dashboard" transform="translate(20.000000, 7.435484)">
            <line x1="6.5" y1="12" x2="6.5" y2="0" id="Path"></line>
            <polyline id="Path" points="3.773 2.727 6.5 0 9.227 2.727"></polyline>
            <path
              d="M4.094,16.312 L7.375,16.312 C7.97919952,16.312 8.469,16.8018005 8.469,17.406 C8.469,18.0101995 7.97919952,18.5 7.375,18.5"
              id="Path"></path>
            <path
              d="M4.094,20.688 L7.812,20.688 C8.41619949,20.688 8.90599993,20.1981995 8.90599993,19.594 C8.90599993,18.9898005 8.41619949,18.5 7.812,18.5 L4.969,18.5"
              id="Path"></path>
            <line x1="4.968" y1="16.313" x2="4.968" y2="20.688" id="Path"></line>
            <line x1="5.293" y1="16.313" x2="5.293" y2="15" id="Path"></line>
            <line x1="7.266" y1="16.313" x2="7.266" y2="15" id="Path"></line>
            <line x1="5.293" y1="22" x2="5.293" y2="20.688" id="Path"></line>
            <line x1="7.266" y1="22" x2="7.266" y2="20.688" id="Path"></line>
            <circle id="Oval" cx="6.5" cy="18.5" r="6.5"></circle>
            <line x1="18.5" y1="13" x2="18.5" y2="25" id="Path"></line>
            <polyline id="Path" points="15.773 22.273 18.5 25 21.227 22.273"></polyline>
            <path
              d="M20.169,4.319 L17.944,4.319 C17.5465274,4.30696228 17.1739858,4.51213746 16.9716931,4.85449255 C16.7694003,5.19684765 16.7694003,5.62215235 16.9716931,5.96450745 C17.1739858,6.30686254 17.5465274,6.51203772 17.944,6.5 L19.056,6.5 C19.4534726,6.48796228 19.8260142,6.69313746 20.0283069,7.03549255 C20.2305997,7.37784765 20.2305997,7.80315235 20.0283069,8.14550745 C19.8260142,8.48786254 19.4534726,8.69303772 19.056,8.681 L16.831,8.681"
              id="Path"></path>
            <line x1="18.5" y1="3" x2="18.5" y2="4.319" id="Path"></line>
            <line x1="18.5" y1="8.681" x2="18.5" y2="10" id="Path"></line>
            <circle id="Oval" cx="18.5" cy="6.5" r="6.5"></circle>
          </g>
        </g>
      </g>
    </svg>
  );
}
